import { render, staticRenderFns } from "./BaseBadge.vue?vue&type=template&id=1e7b160b&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BaseBadge.vue?vue&type=style&index=0&id=1e7b160b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7b160b",
  null
  
)

export default component.exports